// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__aJe2n","savePackageButton":"ClientWallet_savePackageButton__2WX97"};